// components
import { CommunicationsComponent } from './communications.component';
import { OpenCommunicationsComponent } from './open-communications/open.communications.component';
import { CloseCommunicationsComponent } from './close-communications/close.communications.component';
import { DialogCommunicationsComponent } from './dialog-communications/dialog.communications.component';
import { CreateDialogCommunicationsComponent } from './create-dialog-communications/create.dialog.communications.component';
import { SearchCommunicationsComponent } from './search-communications/search-communications.component';

export const COMMUNICATIONS_COMPONENTS: any[] = [
  CommunicationsComponent,
  OpenCommunicationsComponent,
  CloseCommunicationsComponent,
  DialogCommunicationsComponent,
  CreateDialogCommunicationsComponent,
  SearchCommunicationsComponent
];



// WEBPACK FOOTER //
// ./src/app/components/dashboard/communications/index.ts